import { AvailableLocale } from 'types/window'

import systemLocalesCSV from '../../../db_global/tables/system_locales.csv'

// Keep in sync with Global::SystemLocale::SUPERVISOR_ONLY_CODES
// 'en' is the Developer locale, 'hu' is not fully translated yet.
export const SUPERVISOR_ONLY_LOCALE_CODES: ReadonlyArray<string> = ['en', 'hu']

export type SystemLocale = {
  active: string
  code: string
  id: string
  mobile: string
  name: string
  title: string
}

const systemLocales = systemLocalesCSV.map(({ title, ...systemLocale }) => ({
  ...systemLocale,
  name: title,
})) as Array<SystemLocale>

export const setWindowLocaleName = () => {
  window.localeName =
    // `.find()` can actually return undefined at runtime (no matching locale) even though the
    // `as AvailableLocale` cast tells TS otherwise — the `|| 'en'` fallback is still needed.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (systemLocales
      .map((systemLocale) =>
        systemLocale.code.replace(
          /_(.*$)/,
          (_match, p1) => '-' + p1.toUpperCase()
        )
      )
      .find(
        (systemLocaleCode) =>
          systemLocaleCode ===
          window.locale_name.replace(
            /_(.*$)/,
            (_match, p1) => '-' + p1.toUpperCase()
          )
      ) as AvailableLocale) || 'en'
}

export default systemLocales
